import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d1fe8442"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "explore-now-wrap" }
const _hoisted_2 = { class: "explore-now" }

import {storeToRefs} from "pinia";
import {useDataStore, useLocalizationStore} from "@/shared";
import {BlockExploreNow} from "@/entities";


export default /*#__PURE__*/_defineComponent({
  __name: 'explore-now',
  setup(__props) {

const {getArrExploreNow} = storeToRefs(useDataStore());
const {translate} = useLocalizationStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getArrExploreNow), (item, ind) => {
        return (_openBlock(), _createBlock(_unref(BlockExploreNow), {
          key: ind,
          image: item.Image,
          link: item.Link,
          "text-button": _unref(translate)('explore_now'),
          title: _unref(translate)(item.Text)
        }, null, 8, ["image", "link", "text-button", "title"]))
      }), 128))
    ])
  ]))
}
}

})